const E = "customer", _ = "punch_out", o = "employee";
export {
  E as USER_TYPE_CUSTOMER,
  o as USER_TYPE_EMPLOYEE,
  _ as USER_TYPE_PUNCH_OUT
};
